import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { QbrDeleteVersionContent } from './QbrDeleteVersionContent'

interface IProps {
  selectedVersion: IQBRDocumentsListItem
  closeDialog: () => void
  show: boolean
  qbrDocumentsData: IQBRDocumentsListItem[]
  setQbrDocumentsData: (value: IQBRDocumentsListItem[]) => void
  setInitialData: (value: IQBRDocumentsListItem[]) => void
}

export const QbrDeleteVersionDialog = ({
  selectedVersion,
  closeDialog,
  show,
  qbrDocumentsData,
  setQbrDocumentsData,
  setInitialData,
}: IProps) => {
  const contentProps = useMemo(
    () => ({
      selectedVersion,
      closeDialog,
      qbrDocumentsData,
      setQbrDocumentsData,
      setInitialData,
    }),
    [setInitialData, closeDialog, selectedVersion, qbrDocumentsData, setQbrDocumentsData]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={QbrDeleteVersionContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
